import Super from '@simplepractice/ember-messaging-client/models/messaging-profile';

export default Super.extend({});
